// extracted by mini-css-extract-plugin
export default {"Container":"PachesCarousel_Container__t90Zv","Patches":"PachesCarousel_Patches__rH169","Title":"PachesCarousel_Title__6X3I8","ImagePatch":"PachesCarousel_ImagePatch__1G6Wb"};